import { StatusTier } from "entities/tier";
import { useGetUserQuery } from "entities/user";
import { Spiner } from "features/chart";
import { ArrowUpIcon } from "shared/ui";

import styles from "./StatusTiers.module.css";

export const StatusTiers = () => {
  const { data, isLoading } = useGetUserQuery();

  return (
    <div className={styles.statusTiers}>
      <p className={styles.description}>Deposit more, unlock more</p>
      <ul className={styles.tiersList}>
        {isLoading && <Spiner />}
        {data &&
          data.status.tier_ladder.map((tier, idx) => (
            <StatusTier key={tier.tier_code} tier={tier} number={idx + 1} />
          ))}
      </ul>

      <div className={styles.infoBlock}>
        <div className={styles.icon}>
          <ArrowUpIcon color="#5ec062" width={24} height={24} />
        </div>
        <div className={styles.info}>
          <span>Higher status.</span>
          <span className={styles.accent}>Higher value.</span>
          <span>Endless possibilities.</span>
        </div>
      </div>
    </div>
  );
};
